<template>
  <div class="ib-link-wrapper font-outfit-light">
    <router-link
      class="d-flex align-items-center"
      :to="to"
      :style="{'font-size': fontSize}"
    >
      {{ text }}
      <div class="icon-wrapper">
        <i class="icon ib-icon ib-icon-arrow-right-2" />
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'IbLink',

  props: {
    text: {
      type: String,
      required: true
    },
    fontSize: {
      type: String,
      default: '16px'
    },
    to: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.ib-link-wrapper {
  text-decoration: none;

  a {
    color: $color-font !important;
    text-decoration: none;
    font-size: 16px;

    .icon-wrapper {
      position: relative;
      height: 20px;

      .icon {
        transition: all 0.25s ease-in-out !important;
        font-size: 16px;
        position: absolute;
        top: 4px;
        left: 2px;
      }
    }

    &:hover {
      .icon {
        margin-left: 5px;
      }
    }
  }
}
</style>
